"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
function UndoButton(props) {
    const { onClick, onLongPress, disabled, tooltipPlace } = props;
    const { t } = (0, i18n_1.useTranslation)();
    const onEvent = (0, react_1.useCallback)((action) => {
        if (disabled) {
            return;
        }
        switch (action) {
            case ui_1.ActionType.SINGLE_CLICK:
                onClick();
                break;
            case ui_1.ActionType.LONG_CLICK:
                onLongPress();
                break;
            default:
                break;
        }
    }, [disabled, onClick, onLongPress]);
    const [handlers] = (0, ui_1.useLongPressHandlers)(onEvent);
    return ((0, jsx_runtime_1.jsx)(TooltipButton, Object.assign({ tooltip: {
            context: t(i18n_1.Strings.tools.undoRedo.undo),
            place: tooltipPlace,
        }, onClick: () => { }, disabled: disabled, "$flashOnClick": true }, handlers, { children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Undo, width: 24, height: 24 }) })));
}
const TooltipButton = (0, ui_1.withTooltip)(ui_1.ToolBarBaseButton);
exports.default = UndoButton;
